import {create} from "zustand";
import { UserLocale } from '../types';

export interface UserLocaleState {
    userLocale: UserLocale;
    setUserLocale: (userLocale:UserLocale) => void;
    apiStatus: string;//"error" | "idle" | "loading" | "success"
    setApiStatus: (apiStatus:string) => void;
  }

export const useUserLocaleStore = create<UserLocaleState>((set) => ({
   userLocale: {
    locale: "en_US"
   },
   setUserLocale: (userLocale) => set(() => ({ userLocale })),
   apiStatus: "",
   setApiStatus: (apiStatus) => set(() => ({ apiStatus })),
 }));